import styled from 'styled-components';

export const InterstitialContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 38px;

  padding: ${({ theme }) => theme.unit(6)} 0;

  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
    padding: ${({ theme }) => theme.unit(8)} 0;
  }

  @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    padding: ${({ theme }) => theme.unit(10)} 0;
  }
`;

export const ExitTextH1 = styled.h1`
  text-align: center;
  ${({ theme }) => theme.typographyRebrand.heading['xl']}
  color: ${(p) => p.theme.c.text.primary};
  margin: 0;
`;

export const ExitHelpTextH2 = styled.h2`
  text-align: center;
  color: ${(p) => p.theme.c.text.primary};
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  margin: 0;
`;

export const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GenericImg = styled.img`
  max-height: 100%;
  max-width: 100%;
`;

// **** Desktop ****
export const DesktopLogoImgContainer = styled(ImgContainer)`
  width: 345px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const DesktopExitTextH1 = styled(ExitTextH1)`
  margin: 0;
`;

export const DesktopExitHelpTextH2 = styled(ExitHelpTextH2)`
  margin: 0;
`;

export const DesktopShopLogoImgContainer = styled(ImgContainer)`
  width: ${(p) => p.theme.unit(21)};
  height: ${(p) => p.theme.unit(12)};
  padding: ${(p) => p.theme.unit(4)} ${(p) => p.theme.unit(1)}
    ${(p) => p.theme.unit(1)} ${(p) => p.theme.unit(1)};
  box-sizing: border-box;
`;

// **** Mobile ****
export const MobileLogoImgContainer = styled(ImgContainer)`
  widht: 100%;
  margin-top: 0;
  margin-bottom: 0;
`;

export const MobileExitTextH1 = styled(ExitTextH1)`
  margin: 0;
`;

export const MobileExitHelpTextH2 = styled(ExitHelpTextH2)`
  margin: 0;
`;

export const MobileShopLogoImgContainer = styled(DesktopShopLogoImgContainer)`
  width: ${(p) => p.theme.unit(14)};
  height: ${(p) => p.theme.unit(8)};
  padding-top: ${(p) => p.theme.unit(3)};
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(p) => p.theme.unit(2)};
  margin: 0;
  & .action-checkbox-container {
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: ${(p) => p.theme.unit(1)};
    label {
      ${({ theme }) => theme.typographyRebrand.body.md}
      color: ${({ theme }) => theme.c.text.primary};
    }
  }
  & .action-buttons-container {
    display: flex;
    flex-direction: row;
    gap: ${(p) => p.theme.unit(2)};
    @media screen and (max-width: ${p => p.theme.breakpoint.mobile}px) {
      flex-direction: column;
      align-items: center;
    }
  }
`;
